import fetch from "cross-fetch";
import { setContext } from "@apollo/client/link/context";
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";

const link = createHttpLink({
  uri: `${process.env.GATSBY_WORDPRESS_URL}/graphql`,
  credentials: 'include',
  fetchOptions: {
    mode: 'cors',
    credentials: 'include'
  },
});

const getStorageItem = (key) => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage.getItem(key);
};

const authLink = setContext((_, { headers }) => {
  const wooSession = getStorageItem("woo_session");
  const authToken = getStorageItem("auth-token");

  return {
    headers: {
      ...headers,
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
      ...(wooSession ? { Cookie: `wp_woocommerce_session_=${wooSession}` } : {}),
    },
  };
});

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(link),
  defaultOptions: {
    watchQuery: {
      fetchPolicy:'network-only',
      errorPolicy: 'all'
    },
    query: {
      fetchPolicy:'network-only',
      errorPolicy: 'all'
    },
    mutate: {
      errorPolicy: 'all'
    }
  },
  onError: ({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        )
      );
    if (networkError) console.log(`[Network error]: ${networkError}`);
  }
});
